import type { WidgetType } from '@/lib/analytics/widget/widget.type';
import { SIZE_FULL } from '@/lib/gridElements/size';
import {
    FACEBOOK,
    INSTAGRAM,
    LINKEDIN,
    PINTEREST,
    TIKTOK_BUSINESS,
    YOUTUBE
} from '@/lib/socialProfile';

import { GroupMediasWidget } from '@/components/pages/analyze-group/widget/GroupMediasWidget';

export const mostRecentPostsConfig: WidgetType<typeof GroupMediasWidget> = {
    title: 'chart.group.widget_most_recent_posts',
    id: 'widget_most_recent_posts',
    size: SIZE_FULL,
    sortFields: [
        'created',
        'engagement_rate',
        'engagement_on_reach',
        'likes',
        'comments',
        'reach',
        'impressions_views',
        'video_views'
    ],
    type: 'widget',
    aggregatedNetworks: [INSTAGRAM, FACEBOOK, LINKEDIN, TIKTOK_BUSINESS, YOUTUBE, PINTEREST],
    element: GroupMediasWidget
};
